import { ElementDataType } from '@/components/sections/builder/elements/body/cart-total/type';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSetting({ element }: ElementProps) {
  const content = element.data as ElementDataType;

  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  return (
    <div>
      <PaddingSetting
        value={content.padding}
        onChange={(padding) => {
          builder.setElementData(element.id, {
            padding: padding,
          });
        }}
      />
    </div>
  );
}
